import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LayoutDashboard } from "lucide-react";
import { ReactComponent as Logo } from "../../assets/images/AmgenBlueLogo.svg";
import "./Sidebar.css";
import { Box } from "@mui/material";

const Sidebar = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);

  const menuItems = [
    { icon: <LayoutDashboard />, label: "Dashboard", path: "/" },
  ];

  const handleClick = (index, path) => {
    setActiveIndex(index);
    navigate(path);
  };

  return (
    <Box className="side-container">
      <Box className="header-blue">
        <Logo />
      </Box>
      <Box className="side-items">
        {menuItems.map((item, index) => (
          <Box
            key={index}
            className={`side-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => handleClick(index, item.path)}
          >
            <Box className="side-icon">{item.icon}</Box>
            <Box className="side-text">{item.label}</Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Sidebar;
